var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { createHook, createStore } from "react-sweet-state";
import { load, update, LoadingStateDefaults } from "framework/state/loader";
import { setEntityField } from "framework/state/setfield";
import { EntityValidator, FieldValidator } from "framework/validation/validator";
import { NoEntityError, updateByEntityResponse, updateErrorsByEntityResponse } from "framework/validation/validatableentity";
import { apiAthleteIdentification } from "../../../athletes/endpoint";
import { CompetitorType, RegistrationState } from "../../entity";
import { updateByCollectionResponse } from "framework/state/collection";
import { apiGetAvailableCompetitionsForCompetitor, apiCreateCompetitor, apiDeleteCompetitor } from "../../endpoint";
import { StatusCode } from "framework/http/ajax/statusCode";
import { apiGetComponentCompetitors, apiUpdateComponentCompetitors } from "./group_members/endpoint";
import { getAgeTypeRegular } from "public_app/view/entity";
var RegistrationPhase;
(function (RegistrationPhase) {
    RegistrationPhase[RegistrationPhase["None"] = 0] = "None";
    RegistrationPhase[RegistrationPhase["NewCompetitorForm"] = 1] = "NewCompetitorForm";
    RegistrationPhase[RegistrationPhase["AvailableCompetitions"] = 2] = "AvailableCompetitions";
})(RegistrationPhase || (RegistrationPhase = {}));
var CompetitionRegistrationPhase;
(function (CompetitionRegistrationPhase) {
    CompetitionRegistrationPhase[CompetitionRegistrationPhase["None"] = 0] = "None";
    CompetitionRegistrationPhase[CompetitionRegistrationPhase["Submitting"] = 1] = "Submitting";
    CompetitionRegistrationPhase[CompetitionRegistrationPhase["Submitted"] = 2] = "Submitted";
})(CompetitionRegistrationPhase || (CompetitionRegistrationPhase = {}));
var NewAttendeeStateDefaults = __assign(__assign({}, LoadingStateDefaults), { entity: {
        name1: "",
        name2: "",
        surname1: "",
        surname2: "",
        country: null,
    }, errors: __assign({}, NoEntityError) });
var CompetitorClassesStateDefaults = {
    entity: {
        classStt: null,
        classLat: null,
    },
    errors: __assign({}, NoEntityError),
    disciplineId: null,
    seriesId: null,
};
var CompetitionsStateDefaults = __assign(__assign({}, LoadingStateDefaults), { collection: [], errors: __assign({}, NoEntityError), competitions: [], messageUnauthorized: false });
var CompetitionStateDefaults = __assign(__assign({}, LoadingStateDefaults), { entity: null, errors: __assign({}, NoEntityError), messageUnauthorized: false, confirmedRequirementsAreMet: false });
var GroupMembersStateDefaults = __assign(__assign({}, LoadingStateDefaults), { entity: null, errors: __assign({}, NoEntityError), collection_modified: [], dialogIsVisible: false, groupCompetitorId: null, competitionId: null, competitionAgeId: null, toBeReloaded: false, competitorType: null, captain_modified: "" });
var StateDefaults = {
    attendees: [],
    filteredAttendees: [],
    filter: '',
    selectedAttendee: null,
    registrationName: null,
    registrationPhase: RegistrationPhase.None,
    eventId: null,
    eventCompetitionId: null,
    showNewAttendeeIdentification: false,
    newAttendee: null,
    competitions: __assign({}, CompetitionsStateDefaults),
    competitionStates: [],
    showStateSelect: true,
    competitorClassesDialogVisible: false,
    needToReloadAvailableCompetitors: false,
    competitorClasses: CompetitorClassesStateDefaults,
    showOtherCompetitions: false,
    competitorTypeToRegister: null,
    groupMembersState: GroupMembersStateDefaults,
};
var setCompetitorTypeToRegister = function (val) { return function (store) {
    var state = store.getState();
    if (state.competitorTypeToRegister !== val) {
        store.setState(function (draft) {
            draft.competitorTypeToRegister = val;
        });
        store.dispatch(reset(null, null));
    }
}; };
var setConfirmedRequirementsAreMet = function (competitionId, val) { return function (store) {
    var getCompetitionState = function (s) {
        return s.competitionStates.find(function (x) { return x.entity.competitionId == competitionId; });
    };
    store.setState(function (draft) {
        getCompetitionState(draft).confirmedRequirementsAreMet = val;
    });
}; };
var setShowOtherCompetitions = function (val) { return function (store) {
    store.setState(function (draft) {
        draft.showOtherCompetitions = val;
    });
}; };
var showInitialClassesDialog = function (disciplineId, seriesId) { return function (store) {
    store.setState(function (draft) {
        draft.competitorClassesDialogVisible = true;
        draft.competitorClasses.disciplineId = disciplineId;
        draft.competitorClasses.seriesId = seriesId;
    });
}; };
var hideInitialClassesDialog = function () { return function (store) {
    store.setState(function (draft) {
        draft.competitorClassesDialogVisible = false;
    });
}; };
var showStateSelectFunc = function () { return function (store) {
    store.setState(function (draft) {
        draft.showStateSelect = true;
    });
}; };
var createAttendee = function (e, isNew) {
    var _a, _b, _c;
    if (isNew === void 0) { isNew = false; }
    if (e.type == CompetitorType.SoloDancer) {
        return {
            key: "".concat(e.idt1, "-"),
            idt1: e.idt1,
            name: "".concat(e.surname1, " ").concat(e.name1),
            type: e.type,
            isNew: isNew,
            country: e.country,
            competitorAge: e.competitorAge,
            competitorId: (_a = e.competitorId) !== null && _a !== void 0 ? _a : null,
        };
    }
    if (e.type == CompetitorType.Couple) {
        return {
            key: "".concat(e.idt1, "-").concat(e.idt2),
            idt1: e.idt1,
            idt2: e.idt2,
            name: "".concat(e.surname1, " ").concat(e.name1, " & ").concat(e.surname2, " ").concat(e.name2),
            type: e.type,
            isNew: isNew,
            country: e.country,
            competitorAge: e.competitorAge,
            competitorId: (_b = e.competitorId) !== null && _b !== void 0 ? _b : null,
        };
    }
    if (e.type == CompetitorType.Duo) {
        return {
            key: "".concat(e.idt1, "-").concat(e.idt2),
            idt1: e.idt1,
            idt2: e.idt2,
            name: "".concat(e.surname1, " ").concat(e.name1, " & ").concat(e.surname2, " ").concat(e.name2),
            type: e.type,
            isNew: isNew,
            country: e.country,
            competitorAge: e.competitorAge,
            competitorId: (_c = e.competitorId) !== null && _c !== void 0 ? _c : null,
        };
    }
    if ([CompetitorType.Group, CompetitorType.Formation, CompetitorType.Team].includes(e.type)) {
        var competitorName = "".concat(e.name);
        if (e.type === CompetitorType.Team) {
            if (e.competitorAge) {
                competitorName += " - ".concat(getAgeTypeRegular(e.competitorAge));
            }
            if (e.clubName) {
                competitorName += " - ".concat(e.clubName);
            }
        }
        return {
            key: "".concat(e.competitorId),
            competitorId: e.competitorId,
            name: competitorName,
            type: e.type,
            isNew: isNew,
            country: e.country,
            competitorAge: e.competitorAge,
            captain: e.captain,
        };
    }
    return null;
};
var reset = function (eventId, eventCompetitionId) { return function (store) {
    store.setState(function (draft) {
        draft.selectedAttendee = null;
        draft.registrationName = null;
        draft.newAttendee = null;
        draft.registrationPhase = RegistrationPhase.None;
        if (eventId !== null) {
            draft.eventId = eventId;
        }
        if (eventCompetitionId) {
            draft.eventCompetitionId = eventCompetitionId;
        }
    });
}; };
export var attendeeItemNewCouple = { key: '*couple', name: "* nový pár", type: CompetitorType.Couple, isNew: true };
export var attendeeItemNewFemale = { key: '*female', name: "* novou tanečnici", type: CompetitorType.SoloDancer, isNew: true };
export var attendeeItemNewMale = { key: '*male', name: "* nového tanečníka", type: CompetitorType.SoloDancer, isNew: true };
export var attendeeItemNewDuo = { key: '*duo', name: "* nové zahraniční duo", type: CompetitorType.Duo, isNew: true };
export var attendeeItemNewDuoCZE = { key: '*duo_cze', name: "* nové české duo", type: CompetitorType.Duo, isNew: true };
export var attendeeItemNewGroup = { key: '*group', name: "* novou skupinu", type: CompetitorType.Group, isNew: true };
export var attendeeItemNewFormation = { key: '*formation', name: "* novou formaci", type: CompetitorType.Formation, isNew: true };
export var attendeeItemNewTeam = { key: '*team', name: "* nové družstvo", type: CompetitorType.Team, isNew: true };
var setAvailableAttendees = function (attendees) { return function (store) {
    store.setState(function (draft) {
        var _a;
        draft.attendees = [];
        draft.attendees.push(attendeeItemNewCouple);
        draft.attendees.push(attendeeItemNewFemale);
        draft.attendees.push(attendeeItemNewMale);
        draft.attendees.push(attendeeItemNewDuo);
        draft.attendees.push(attendeeItemNewDuoCZE);
        draft.attendees.push(attendeeItemNewGroup);
        draft.attendees.push(attendeeItemNewFormation);
        draft.attendees.push(attendeeItemNewTeam);
        (_a = draft.attendees).push.apply(_a, attendees.map(function (x) { return createAttendee(x); }).filter(function (x) { return x !== null; }));
    });
}; };
var setFilter = function (filter) { return function (store) {
    store.setState(function (draft) {
        draft.filter = filter;
    });
}; };
var setFilteredAttendees = function (attendees) { return function (store) {
    store.setState(function (draft) {
        draft.filteredAttendees = attendees;
    });
}; };
var selectAttendee = function (key) { return function (store) {
    if (key && key != '-') {
        store.setState(function (draft) {
            var attendee = draft.attendees.find(function (x) { return x.key == key; });
            if (attendee.isNew) {
                var gender1 = undefined;
                var gender2 = undefined;
                if (attendee.type === CompetitorType.SoloDancer) {
                    if (key == '*female') {
                        gender1 = "F";
                    }
                    if (key == '*male') {
                        gender1 = "M";
                    }
                }
                if (attendee.type === CompetitorType.Couple) {
                    gender1 = "M";
                    gender2 = "F";
                }
                if (attendee.type === CompetitorType.Duo) {
                    gender1 = "F";
                    gender2 = "F";
                }
                var newAttendee = __assign(__assign({}, NewAttendeeStateDefaults), {
                    entity: {
                        sex1: gender1,
                        sex2: gender2,
                        idt1: attendee.idt1,
                        idt2: attendee.idt2,
                        // country: "",
                    }
                });
                draft.newAttendee = newAttendee;
                draft.registrationPhase = RegistrationPhase.NewCompetitorForm;
                draft.registrationName = "";
                draft.showStateSelect = false;
            }
            else {
                draft.registrationName = attendee.name;
                draft.registrationPhase = RegistrationPhase.AvailableCompetitions;
                draft.newAttendee = null;
            }
            draft.showOtherCompetitions = false;
            draft.selectedAttendee = attendee;
            draft.competitions.initialized = false;
            draft.competitorClasses = __assign({}, CompetitorClassesStateDefaults);
        });
    }
}; };
var registerOtherAttendee = function () { return function (store) {
    var _a = store.getState(), eventId = _a.eventId, eventCompetitionId = _a.eventCompetitionId;
    store.dispatch(reset(eventId, eventCompetitionId));
}; };
/********* New Attendee ***********/
var validateNewAttendee = function (store) {
    var _a;
    var _b = store.getState(), newAttendee = _b.newAttendee, selectedAttendee = _b.selectedAttendee;
    var entity = newAttendee.entity;
    var validator = EntityValidator();
    if (![CompetitorType.Couple, CompetitorType.Duo, CompetitorType.SoloDancer, CompetitorType.Group, CompetitorType.Formation, CompetitorType.Team].includes(selectedAttendee.type)) {
        return false;
    }
    if ([CompetitorType.Couple, CompetitorType.Duo, CompetitorType.SoloDancer].includes(selectedAttendee.type)) {
        validator.storeFieldResult("name1", FieldValidator()
            .validateNotEmpty(entity.name1)
            .getResult());
        validator.storeFieldResult("surname1", FieldValidator()
            .validateNotEmpty(entity.surname1)
            .getResult());
        validator.storeFieldResult("birthDate1", FieldValidator()
            .validateNotEmpty(entity.birthDate1)
            .getResult());
        validator.storeFieldResult("sex1", FieldValidator()
            .validateNotEmpty(entity.sex1)
            .getResult());
    }
    if ([CompetitorType.Couple, CompetitorType.Duo].includes(selectedAttendee.type)) {
        validator.storeFieldResult("name2", FieldValidator()
            .validateNotEmpty(entity.name2)
            .getResult());
        validator.storeFieldResult("surname2", FieldValidator()
            .validateNotEmpty(entity.surname2)
            .getResult());
        validator.storeFieldResult("birthDate2", FieldValidator()
            .validateNotEmpty(entity.birthDate2)
            .getResult());
        validator.storeFieldResult("sex2", FieldValidator()
            .validateNotEmpty(entity.sex2)
            .getResult());
    }
    if ([CompetitorType.Group, CompetitorType.Formation, CompetitorType.Team].includes(selectedAttendee.type)) {
        validator.storeFieldResult("name", FieldValidator()
            .validateNotEmpty(entity.name)
            .getResult());
    }
    if (selectedAttendee.type === CompetitorType.Team) {
        validator.storeFieldResult("age", FieldValidator()
            .validateNotEmpty(entity.age)
            .getResult());
    }
    if ([CompetitorType.Formation, CompetitorType.Team].includes(selectedAttendee.type)) {
        validator.storeFieldResult("clubId", FieldValidator()
            .validateNotEmpty(entity.clubId)
            .getResult());
    }
    if (selectedAttendee.type === CompetitorType.Group) {
        if (((_a = newAttendee.entity) === null || _a === void 0 ? void 0 : _a.clubId) === -1) {
            validator.storeFieldResult("club", FieldValidator()
                .validateNotEmpty(entity.club)
                .getResult());
        }
        else {
            validator.storeFieldResult("clubId", FieldValidator()
                .validateNotEmpty(entity.clubId)
                .getResult());
        }
    }
    if (![CompetitorType.Formation, CompetitorType.Team].includes(selectedAttendee.type)) {
        validator.storeFieldResult("country", FieldValidator()
            .validateNotEmpty(entity.country)
            .getResult());
    }
    store.setState(function (draft) {
        draft.newAttendee.errors = validator.getResult();
    });
    return validator.isValid();
};
var checkNewAttendeeValidityAndRegisterIfDoesNotExist = function () { return function (store) {
    if (!validateNewAttendee(store)) {
        return;
    }
    store.setState(function (draft) {
        var selectedAttendee = draft.selectedAttendee, newAttendee = draft.newAttendee;
        var entity = newAttendee.entity;
        var name = null;
        if ([CompetitorType.SoloDancer, CompetitorType.Couple, CompetitorType.Duo].includes(selectedAttendee.type)) {
            selectedAttendee.birthDate1 = entity.birthDate1;
            selectedAttendee.sex1 = entity.sex1;
            name = "".concat(entity.surname1, " ").concat(entity.name1);
        }
        if ([CompetitorType.Couple, CompetitorType.Duo].includes(selectedAttendee.type)) {
            selectedAttendee.birthDate2 = entity.birthDate2;
            selectedAttendee.sex2 = entity.sex2;
            name = "".concat(entity.surname1, " ").concat(entity.name1, " & ").concat(entity.surname2, " ").concat(entity.name2);
        }
        if ([CompetitorType.Group, CompetitorType.Formation, CompetitorType.Team].includes(selectedAttendee.type)) {
            selectedAttendee.name = entity.name;
            selectedAttendee.club = entity.club;
            selectedAttendee.captain = entity.captain;
            name = "".concat(entity.name);
        }
        draft.registrationName = name;
    });
    var _a = store.getState(), newAttendee = _a.newAttendee, selectedAttendee = _a.selectedAttendee;
    var entity = newAttendee.entity;
    var ath = {
        country: entity.country,
    };
    if ([CompetitorType.SoloDancer, CompetitorType.Couple, CompetitorType.Duo].includes(selectedAttendee.type)) {
        ath.idt1 = entity.idt1;
        ath.name1 = entity.name1;
        ath.surname1 = entity.surname1;
        ath.birthDate1 = entity.birthDate1;
        ath.sex1 = entity.sex1;
    }
    if ([CompetitorType.Couple, CompetitorType.Duo].includes(selectedAttendee.type)) {
        ath.idt2 = entity.idt2;
        ath.name2 = entity.name2;
        ath.surname2 = entity.surname2;
        ath.birthDate2 = entity.birthDate2;
        ath.sex2 = entity.sex2;
    }
    if ([CompetitorType.Group, CompetitorType.Formation, CompetitorType.Team].includes(selectedAttendee.type)) {
        ath.name = entity.name;
        ath.club = entity.club;
        ath.captain = entity.captain;
        ath.type = selectedAttendee.type;
        ath.age = entity.age;
        ath.clubId = entity.clubId > 0 ? entity.clubId : undefined;
        ath.club = entity.clubId === -1 ? entity.club : undefined;
    }
    var updater = function () { return apiAthleteIdentification(ath); };
    var stateProducer = function (store, _, response) {
        store.setState(function (draft) {
            if (response.succeeded) {
                draft.newAttendee.entity.idt1 = response.data.entity.idt1;
                draft.newAttendee.entity.idt2 = response.data.entity.idt2;
                draft.newAttendee.entity.competitorId = response.data.entity.competitorId;
                draft.selectedAttendee.idt1 = response.data.entity.idt1;
                draft.selectedAttendee.idt2 = response.data.entity.idt2;
                draft.selectedAttendee.competitorId = response.data.entity.competitorId;
                draft.selectedAttendee.country = draft.newAttendee.entity.country;
                draft.registrationPhase = RegistrationPhase.AvailableCompetitions;
                draft.needToReloadAvailableCompetitors = true;
            }
            else {
                updateErrorsByEntityResponse(draft.newAttendee, response);
                draft.registrationPhase = RegistrationPhase.NewCompetitorForm;
            }
        });
    };
    update(store, updater, stateProducer, function (s) { return s.newAttendee; });
}; };
var setNeedToReloadAvailableCompetitorsFalse = function () { return function (store) {
    store.setState(function (draft) {
        draft.needToReloadAvailableCompetitors = false;
    });
}; };
var setNewAttendeeField = function (field, value, validator, storeInvalidValue) { return function (store) {
    var val = value;
    if (['clubId', 'age'].includes(field)) {
        val = value ? parseInt(value) : null;
    }
    store.setState(function (draft) {
        setEntityField(draft.newAttendee, field, val, validator, storeInvalidValue);
    });
}; };
var setCompetitorClassField = function (field, value, validator, storeInvalidValue) { return function (store) {
    store.setState(function (draft) {
        setEntityField(draft.competitorClasses, field, parseInt(value), validator, storeInvalidValue);
    });
}; };
/********* Competitions ***********/
var loadAvailableCompetitions = function () { return function (store) {
    store.setState(function (draft) {
        draft.competitionStates = [];
        draft.competitorClassesDialogVisible = false;
        draft.competitions.messageUnauthorized = false;
    });
    var _a = store.getState(), selectedAttendee = _a.selectedAttendee, eventId = _a.eventId, eventCompetitionId = _a.eventCompetitionId, competitorClasses = _a.competitorClasses;
    var compInfo = {
        idt1: selectedAttendee.idt1,
        idt2: selectedAttendee.idt2,
        competitorId: [CompetitorType.Group, CompetitorType.Formation, CompetitorType.Team].includes(selectedAttendee.type) ? selectedAttendee.competitorId : null,
        classStt: competitorClasses.entity.classStt !== null ? competitorClasses.entity.classStt : undefined,
        classLat: competitorClasses.entity.classLat !== null ? competitorClasses.entity.classLat : undefined,
    };
    if (selectedAttendee.country !== 'CZE') {
        compInfo.country = selectedAttendee.country;
    }
    var loader = function () { return apiGetAvailableCompetitionsForCompetitor(compInfo, eventId, eventCompetitionId); };
    var stateProducer = function (store, _, response) {
        store.setState(function (draft) {
            updateByCollectionResponse(draft.competitions, response);
            var competitor = __assign(__assign({}, LoadingStateDefaults), { entity: {
                    competitorId: 0,
                    eventId: 0,
                    competitionId: 0,
                    type: selectedAttendee.type,
                }, errors: __assign({}, NoEntityError) });
            var getCompetitionItem = function (c) {
                return __assign(__assign({}, c), { competitor: competitor, register: c.registrationState === RegistrationState.Registered, registrationPhase: CompetitionRegistrationPhase.None });
            };
            draft.competitions.competitions = response.succeeded
                ? draft.competitions.collection.flatMap(function (c) { return getCompetitionItem(c); })
                : [];
            if (response.succeeded) {
                draft.competitionStates = [];
                draft.competitions.collection.forEach(function (c) {
                    draft.competitionStates.push(__assign(__assign({}, CompetitionStateDefaults), { entity: c }));
                });
            }
            else {
                if (response.status === StatusCode.Unauthorized) {
                    draft.competitions.messageUnauthorized = true;
                }
            }
        });
    };
    load(store, loader, stateProducer, function (s) { return s.competitions; });
}; };
var registerForCompetition = function (eventId, competitionId) { return function (store) {
    var getCompetitionState = function (s) {
        return s.competitionStates.find(function (x) { return x.entity.competitionId == competitionId; });
    };
    var state = store.getState();
    store.setState(function (draft) {
        var cs = getCompetitionState(draft);
        cs.messageUnauthorized = false;
    });
    var competitionItem = state.competitions.competitions.find(function (x) { return x.competitionId == competitionId; });
    var entity = createCompetitorEntity(competitionItem, state.selectedAttendee);
    var register = competitionItem.register;
    var loader = function () { return apiCreateCompetitor(entity.eventId, entity); };
    var stateProducer = function (store, _, response) {
        store.setState(function (draft) {
            var competitionItem = draft.competitions.competitions.find(function (x) { return x.competitionId == competitionId; });
            // updateByEntityResponse(competitionItem.competitor, response);
            var cs = getCompetitionState(draft);
            if (response.succeeded) {
                var competitor = __assign(__assign({}, LoadingStateDefaults), { entity: null, errors: __assign({}, NoEntityError) });
                updateByEntityResponse(competitor, response);
                cs.entity.registrationState = RegistrationState.Registered;
                cs.entity.competitorId = competitor.entity.competitorId;
            }
            else {
                if (response.status === StatusCode.Unauthorized) {
                    cs.messageUnauthorized = true;
                }
            }
        });
    };
    load(store, loader, stateProducer, getCompetitionState);
}; };
var cancelRegistrationForCompetition = function (eventId, competitionId, competitorId) { return function (store) {
    var state = store.getState();
    var loader = function () { return apiDeleteCompetitor(eventId, competitionId, competitorId); };
    var getCompetitionState = function (s) {
        return s.competitionStates.find(function (x) { return x.entity.competitionId == competitionId; });
    };
    var stateProducer = function (store, _, response) {
        store.setState(function (draft) {
            var competitionItem = draft.competitions.competitions.find(function (x) { return x.competitionId == competitionId; });
            // updateByEntityResponse(competitionItem.competitor, response);
            if (response.succeeded) {
                var cs = getCompetitionState(draft);
                cs.entity.registrationState = undefined;
                cs.entity.competitorId = null;
            }
        });
    };
    load(store, loader, stateProducer, getCompetitionState);
}; };
/********* Competition ***********/
var setCompetitionRegistration = function (competitionId, register) { return function (store) {
    store.setState(function (draft) {
        var comp = draft.competitions.competitions.find(function (x) { return x.competitionId == competitionId; });
        if (comp != null) {
            comp.register = register;
        }
    });
}; };
var setCompetitor_Couple = function (competitor, ci, national) {
    var entity = {
        idt1: ci.idt1,
        idt2: ci.idt2,
        name1: ci.name1,
        surname1: ci.surname1,
        name2: ci.name2,
        surname2: ci.surname2,
        sex1: ci.sex1,
        sex2: ci.sex2,
        birthDate1: ci.birthDate1,
        birthDate2: ci.birthDate2,
        backup: false,
    };
    competitor.couplesOrDuos = [entity];
    competitor.country = ci.country;
};
var setCompetitor_Duo = function (competitor, ci, national) {
    var coupleOrDuo = {
        idt1: ci.idt1,
        idt2: ci.idt2,
        name1: ci.name1,
        surname1: ci.surname1,
        name2: ci.name2,
        surname2: ci.surname2,
        sex1: ci.sex1,
        sex2: ci.sex2,
        birthDate1: ci.birthDate1,
        birthDate2: ci.birthDate2,
        backup: false,
    };
    competitor.couplesOrDuos = [coupleOrDuo];
    competitor.country = ci.country;
};
var setCompetitor_Solo = function (competitor, ci, national) {
    var person = {
        idt: ci.idt1,
        name: ci.name1,
        surname: ci.surname1,
        sex: ci.sex1,
        birthDate: ci.birthDate1,
        backup: false,
    };
    competitor.persons = [person];
    competitor.country = ci.country;
};
var setCompetitor_Group_Formation_Team = function (competitor, ci) {
    competitor.competitorId = ci.competitorId;
    competitor.country = ci.country;
};
var createCompetitorEntity = function (competitionItem, competitorInfo) {
    var _a, _b;
    var competitorId = competitionItem.competitorId, eventId = competitionItem.eventId, competitionId = competitionItem.competitionId, competitorTypeId = competitionItem.competitorTypeId;
    var result = {
        competitorId: competitorId ? competitorId : (_b = (_a = competitionItem.competitor) === null || _a === void 0 ? void 0 : _a.entity) === null || _b === void 0 ? void 0 : _b.competitorId,
        eventId: eventId,
        competitionId: competitionId,
        type: competitorTypeId,
    };
    var national = competitorInfo.country == "CZE";
    switch (competitorTypeId) {
        case CompetitorType.Couple:
            setCompetitor_Couple(result, competitorInfo, national);
            break;
        case CompetitorType.Duo:
            setCompetitor_Duo(result, competitorInfo, national);
            break;
        case CompetitorType.SoloDancer:
            setCompetitor_Solo(result, competitorInfo, national);
            break;
        case CompetitorType.Group:
            setCompetitor_Group_Formation_Team(result, competitorInfo);
            break;
        case CompetitorType.SmallTeam:
            setCompetitor_Group_Formation_Team(result, competitorInfo);
            break;
        case CompetitorType.BigTeam:
            setCompetitor_Group_Formation_Team(result, competitorInfo);
            break;
        case CompetitorType.Formation:
            setCompetitor_Group_Formation_Team(result, competitorInfo);
            break;
        case CompetitorType.Team:
            setCompetitor_Group_Formation_Team(result, competitorInfo);
            break;
    }
    return result;
};
var showGroupMembersDialog = function (groupCompetitorId, competitionId, ageId, competitorType) { return function (store) {
    store.setState(function (draft) {
        draft.groupMembersState.dialogIsVisible = true;
        draft.groupMembersState.groupCompetitorId = groupCompetitorId;
        draft.groupMembersState.competitionId = competitionId;
        draft.groupMembersState.competitionAgeId = ageId;
        draft.groupMembersState.competitorType = competitorType;
        draft.groupMembersState.entity = null;
        draft.groupMembersState.collection_modified = [];
        draft.groupMembersState.captain_modified = "";
        resetGroupErrors(draft);
    });
}; };
var hideGroupMembersDialog = function () { return function (store) {
    store.setState(function (draft) {
        draft.groupMembersState.dialogIsVisible = false;
        draft.groupMembersState.groupCompetitorId = null;
        draft.groupMembersState.competitionId = null;
        draft.groupMembersState.competitionAgeId = null;
        resetGroupErrors(draft);
    });
}; };
var setCaptainField = function (value) { return function (store) {
    store.setState(function (draft) {
        var _a;
        draft.groupMembersState.captain_modified = value;
        if (value !== ((_a = draft.groupMembersState.entity) === null || _a === void 0 ? void 0 : _a.captain) && draft.groupMembersState.errors["captain"]) {
            draft.groupMembersState.errors["captain"] = undefined;
        }
    });
}; };
var setGroupMemberAssignment = function (competitorId, membership) { return function (store) {
    store.setState(function (draft) {
        var index = draft.groupMembersState.collection_modified.findIndex(function (m) { return m.componentCompetitorId === competitorId; });
        if (membership) {
            if (index === -1) {
                draft.groupMembersState.collection_modified.push({
                    componentCompetitorId: competitorId,
                    order: 0,
                    backup: false
                });
            }
        }
        else {
            if (index >= 0) {
                draft.groupMembersState.collection_modified.splice(index, 1);
            }
        }
    });
}; };
var setGroupMemberBackupValue = function (competitorId, backup) { return function (store) {
    store.setState(function (draft) {
        var index = draft.groupMembersState.collection_modified.findIndex(function (m) { return m.componentCompetitorId === competitorId; });
        if (index >= 0) {
            draft.groupMembersState.collection_modified[index].backup = backup;
        }
    });
}; };
var loadGroupMembers = function (groupCompetitorId, competitionId) { return function (store) {
    store.setState(function (draft) {
        draft.groupMembersState.toBeReloaded = false;
    });
    var loader = function () { return apiGetComponentCompetitors(groupCompetitorId, competitionId); };
    var stateProducer = function (store, _, response) {
        store.setState(function (draft) {
            updateByEntityResponse(draft.groupMembersState, response);
            if (response.succeeded) {
                draft.groupMembersState.collection_modified = draft.groupMembersState.entity.components;
                draft.groupMembersState.captain_modified = draft.groupMembersState.entity.captain;
            }
        });
    };
    load(store, loader, stateProducer, function (s) { return s.groupMembersState; });
}; };
var saveGroupMembers = function () { return function (store) {
    var state = store.getState();
    var updater = function () { return apiUpdateComponentCompetitors(state.groupMembersState.groupCompetitorId, state.groupMembersState.competitionId, state.groupMembersState.collection_modified, state.groupMembersState.captain_modified); };
    var stateProducer = function (store, _, response) {
        store.setState(function (draft) {
            if (response.succeeded) {
                draft.groupMembersState.toBeReloaded = true;
            }
            else {
                if (response.status == undefined) { // for StatusCode.NoContent - no idea why
                    draft.groupMembersState.toBeReloaded = true;
                }
                else {
                    updateByEntityResponse(draft.groupMembersState, response);
                }
            }
        });
    };
    update(store, updater, stateProducer, function (s) { return s.groupMembersState; });
}; };
var resetGroupErrors = function (draft) {
    draft.groupMembersState.errors = __assign({}, NoEntityError);
};
var store = createStore({
    initialState: StateDefaults,
    actions: {
        reset: reset,
        setAvailableAttendees: setAvailableAttendees,
        selectAttendee: selectAttendee,
        checkNewAttendeeValidityAndRegisterIfDoesNotExist: checkNewAttendeeValidityAndRegisterIfDoesNotExist,
        setNewAttendeeField: setNewAttendeeField,
        setCompetitorClassField: setCompetitorClassField,
        loadAvailableCompetitions: loadAvailableCompetitions,
        setCompetitionRegistration: setCompetitionRegistration,
        registerOtherAttendee: registerOtherAttendee,
        setFilter: setFilter,
        setFilteredAttendees: setFilteredAttendees,
        showStateSelectFunc: showStateSelectFunc,
        registerForCompetition: registerForCompetition,
        cancelRegistrationForCompetition: cancelRegistrationForCompetition,
        showInitialClassesDialog: showInitialClassesDialog,
        hideInitialClassesDialog: hideInitialClassesDialog,
        setNeedToReloadAvailableCompetitorsFalse: setNeedToReloadAvailableCompetitorsFalse,
        setShowOtherCompetitions: setShowOtherCompetitions,
        setCompetitorTypeToRegister: setCompetitorTypeToRegister,
        showGroupMembersDialog: showGroupMembersDialog,
        hideGroupMembersDialog: hideGroupMembersDialog,
        loadGroupMembers: loadGroupMembers,
        saveGroupMembers: saveGroupMembers,
        setGroupMemberAssignment: setGroupMemberAssignment,
        setGroupMemberBackupValue: setGroupMemberBackupValue,
        setConfirmedRequirementsAreMet: setConfirmedRequirementsAreMet,
        setCaptainField: setCaptainField,
    },
    name: "CompetitionRegistration"
});
var useState = createHook(store);
export { RegistrationPhase, StateDefaults as CompetitionRegistrationDefaults, useState as useCompetitionRegistration, };
